import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Context } from "./Utils/Store";
import axios from "axios";
import Button from "@mui/material/Button";
import { getAppSettings } from "./Utils/AppSettings";
import "./css/App.css";

function Data() {

  const history = useHistory();
  const [store] = useContext(Context);
  const [route, setRoute] = useState("");
  const [routeList, setRouteList] = useState([]);
  const [jobCode, setJobCode] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [students, setStudents] = useState(0);
  const [busNumber, setBusNumber] = useState("");
  const [beginTime, setBeginTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [beginOdometer, setBeginOdometer] = useState(0);
  const [endOdometer, setEndOdometer] = useState(0);
  const [loading, setLoading] = useState(true);
  const [changed, setChanged] = useState(false);
  const settings = getAppSettings();

  const handleSave = () => {

    const tripObject = {
      TLKey: store.trip.TLKey,
      EMKey: store.driver.EMKey,
      HomeDept: String(store.driver.JobCode).slice(-2),
      LoginName: store.driver.LoginName,
      PeriodDate: String(store.driver.PeriodEnd).slice(0, 10),
      WorkDate: store.workday,
      RouteNumber: route === "Select Route" ? "" : route,
      JobCode: jobCode.slice(0, 2),
      CustomerNumber: customer.length === 0 ? store.driver.CustomerNumber : customer.slice(0, 2),
      StudentCount: students ? students : 0,
      BusNumber: busNumber,
      BeginTime: beginTime,
      EndTime: endTime,
      BeginOdometer: beginOdometer ? beginOdometer : 0,
      EndOdometer: endOdometer ? endOdometer : 0
    }

    if (tripObject.JobCode === "06" || tripObject.JobCode === '12' || tripObject.JobCode === '13' || tripObject.JobCode === '14' || tripObject.JobCode === '15' || tripObject.JobCode === '17' || tripObject.JobCode === '23') {
      tripObject.StudentCount = 0;
      tripObject.BeginOdometer = 0;
      tripObject.EndOdometer = 0;
    }

    axios.post(settings.apiUrl + '/driver/saveday', tripObject).then(response => {
      if (response.status === 200) {
        history.goBack();
      } else {
        console.log("response status: " + response.status + " " + response.statusText);
      }
    }).catch(error => {
      console.log(error);
    });

  }

  const handleBack = () => {
    history.goBack();
  }

  const handleDelete = () => {

    if (store.trip.TLKey === 0) {
      history.goBack();
    } else {

      const tripObject = {
        TLKey: store.trip.TLKey,
        EMKey: store.driver.EMKey,
        WorkDate: store.workday
      }

      axios.post(settings.apiUrl + '/driver/delday', tripObject).then(response => {
        if (response.status === 200) {
          history.goBack();
        } else {
          console.log("response status: " + response.status + " " + response.statusText);
        }
      }).catch(error => {
        console.log(error);
      });
    }

  }

  const getRouteList = (data) => {
    const routes = [];
    routes.push(<option key="sr-1">Select Route</option>);

    data.map((item) => {
      routes.push(<option key={item.RNKey}>{item.RouteNumber}</option>);
      return null;
    });

    return routes;
  }

  const handleRoute = (route) => {
    setRoute(route);

    if (jobCode !== '06 - Aide/Monitor') {
      switch (route.slice(2, 3)) {
        case "1":
          setJobCode("01 - Special ED");
          break;
        case "2":
          setJobCode("02 - Regular HTS");
          break;
        case "3":
          setJobCode("03 - Midday/Late");
          break;
        default:
          setJobCode("Select Type");
          break;
      }
    }
  }

  const formatJobCode = (val) => {
    switch (val) {
      case "01":
        return "01 - Special ED";
      case "02":
        return "02 - Regular HTS";
      case "03":
        return "03 - Midday/Late";
      case "06":
        return "06 - Aide/Monitor";
      case "12":
        return "12 - Trainer";
      case "13":
        return "13 - Maintenance";
      case "15":
        return "15 - Administration";
      case "17":
        return "17 - Fueler/Washer";
      case "23":
        return "23 - Trainee";
      default:
        return "Select Type";
    }
  }

  const handleCustomer = useCallback((item) => {
    setCustomer(item)

    if (item === "Select District" || item.length === 0) {
      setJobCode(formatJobCode(store.trip.JobCode));
    } else if (route === "Select Route") {
      setJobCode("Select Type");
    }

    const customerObject = {
      CustomerNumber: String(item).slice(0, 2)
    }

    axios.post(settings.apiUrl + '/driver/loadroutes', customerObject).then(response => {
      if (response.status === 200) {
        setRouteList(getRouteList(response.data));
        if (customerObject.CustomerNumber !== store.trip.CustomerNumber) {
          setRoute("Select Route");
        }
      } else {
        console.log("response status: " + response.status + " " + response.statusText);
      }
    }).catch(error => {
      console.log(error);
    });
  }, [settings, store]);

  const formatZero = (val) => {
    if (Number(val) === 0) {
      return "";
    } else {
      return val;
    }
  }

  const handleStudents = (val) => {
    setStudents(formatZero(val.replace(/\D/g, "")));
  }

  const handleBusNumber = (val) => {
    setBusNumber(formatZero(val.replace(/\D/g, "")));
  }

  const handleBeginOD = (val) => {
    setBeginOdometer(formatZero(val.replace(/\D/g, "")));
  }

  const handleEndOD = (val) => {
    setEndOdometer(formatZero(val.replace(/\D/g, "")));
  }

  const handleBeginTime = (e) => {
    const timeval = e.target.value;

    if (timeval < "05:00" || timeval > "20:00") {
      setBeginTime("");
    } else {
      setBeginTime(timeval);
    }

    setChanged(true);
  }

  const handleEndTime = (e) => {
    const timeval = e.target.value;

    if (beginTime === "" || timeval <= beginTime || timeval < "05:00" || timeval > "21:00") {
      setEndTime("");
    } else {
      setEndTime(timeval);
    }

    setChanged(true);
  }

  const saveDisabled = () => {
    const job = jobCode.slice(0, 2);
    return route === "Select Route" && job !== '12' && job !== '13' && job !== '14' && job !== '15' && job !== '17' && job !== '23';
  }

  const studentsDisabled = () => {
    const job = jobCode.slice(0, 2);
    return job === "06" || job === '12' || job === '13' || job === '14' || job === '15' || job === '17' || job === '23';
  }

  const odometerDisabled = () => {
    const job = jobCode.slice(0, 2);
    return job === "06" || job === '12' || job === '14' || job === '15' || job === '17' || job === '23';
  }

  const busNumberDisabled = () => {
    const job = jobCode.slice(0, 2);
    return job === "06" || job === '12' || job === '14' || job === '15' || job === '17' || job === '23';
  }

  const jobType = () => {
    const job = jobCode.slice(0, 2);
    if (job === '12' || job === '13' || job === '14' || job === '15' || job === '17' || job === '23') {
      return "Work";
    } else {
      return "Route";
    }
  }

  useEffect(() => {

    const formatCustomer = (val) => {
      let customerItem = "";
      store.driver.CustomerList.some((item) => {
        if (val === item.CustomerNumber) {
          customerItem = val + " - " + item.CustomerName;
        }
        return null;
      });
      return customerItem;
    }

    const getCustomerList = () => {
      const customers = []
      customers.push(<option key={0}>Select District</option>);
      store.driver.CustomerList.map((item) => {
        customers.push(<option key={item.CUKey}>{item.CustomerNumber + " - " + item.CustomerName}</option>);
        return null;
      });

      return customers;
    }

    if (loading) {
      setLoading(false);
      setCustomer(formatCustomer(store.trip.CustomerNumber));
      setCustomerList(getCustomerList());
      setRoute(store.trip.RouteNumber);
      setJobCode(formatJobCode(store.trip.JobCode));
      setStudents(formatZero(store.trip.StudentCount));
      setBusNumber(store.trip.BusNumber);
      setBeginTime(store.trip.BeginTime);
      setEndTime(store.trip.EndTime);
      setBeginOdometer(formatZero(store.trip.BeginOdometer));
      setEndOdometer(formatZero(store.trip.EndOdometer));
      handleCustomer(formatCustomer(store.trip.CustomerNumber));
    }
  }, [loading, store, handleCustomer]);

  return (
    <div className="page">
      <div className="vbox">
        <div className="employee">{store.driver.DriverName}</div>
        <div><b>Trip Details For {store.daylabel}</b></div>
        <div className="spacer10x20" />
      </div>
      <table>
        <tbody>
          <tr>
            <td><div className="labelData">District</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <select value={customer} onChange={(e) => { handleCustomer(e.target.value); setChanged(true); }} >
                  {customerList}
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td><div className="labelData">Route</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <select value={route} onChange={(e) => { handleRoute(e.target.value); setChanged(true); }} >
                  {routeList}
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td><div className="labelData">Type</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <select value={jobCode} onChange={(e) => { setJobCode(e.target.value); setChanged(true); }} >
                  <option>Select Type</option>
                  <option disabled={route.slice(2, 3) !== "1" && route.slice(2, 3) !== "4"}>01 - Special ED</option>
                  <option disabled={route.slice(2, 3) !== "2" && route.slice(2, 3) !== "4"}>02 - Regular HTS</option>
                  <option disabled={route.slice(2, 3) !== "3" && route.slice(2, 3) !== "4"}>03 - Midday/Late</option>
                  <option disabled={route.slice(0, 1) === 'S'}>06 - Aide/Monitor</option>
                  <option disabled={route.slice(0, 1) !== 'S'}>12 - Trainer</option>
                  <option disabled={route.slice(0, 1) !== 'S'}>13 - Maintenance</option>
                  <option disabled={route.slice(0, 1) !== 'S'}>14 - Dispatch</option>
                  <option disabled={route.slice(0, 1) !== 'S'}>15 - Administration</option>
                  <option disabled={route.slice(0, 1) !== 'S'}>17 - Fueler/Washer</option>
                  <option disabled={route.slice(0, 1) !== 'S'}>23 - Trainee</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td><div className="labelData">Students</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <input className="inputData" type="tel" disabled={studentsDisabled()} value={students} onChange={(e) => { handleStudents(e.target.value); setChanged(true); }} />
              </div>
            </td>
          </tr>
          <tr>
            <td><div className="labelData">Bus Number</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <input className="inputData" type="tel" disabled={busNumberDisabled()} value={busNumber} onChange={(e) => { handleBusNumber(e.target.value); setChanged(true); }} />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan="3"><div className="labelData vbox top12">--- Begin {jobType()} ---</div></td>
          </tr>
          <tr>
            <td><div className="labelData">Time</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <input className="inputTime" type="time" value={beginTime} onChange={handleBeginTime} />
              </div>
            </td>
          </tr>
          <tr>
            <td><div className="labelData">Odometer</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <input className="inputData" type="tel" disabled={odometerDisabled()} value={beginOdometer} onChange={(e) => { handleBeginOD(e.target.value); setChanged(true); }} />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan="3"><div className="labelData vbox top12">--- End {jobType()} ---</div></td>
          </tr>
          <tr>
            <td><div className="labelData">Time</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <input className="inputTime" type="time" value={endTime} onChange={handleEndTime} />
              </div>
            </td>
          </tr>
          <tr>
            <td><div className="labelData">Odometer</div></td>
            <td><div className="spacer10x20" /></td>
            <td>
              <div>
                <input className="inputData" type="tel" disabled={odometerDisabled()} value={endOdometer} onChange={(e) => { handleEndOD(e.target.value); setChanged(true); }} />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="spacer10x20" />
      <div className="hbox databox">
        <Button variant="contained" onClick={handleDelete}>DELETE</Button>
        <Button variant="contained" onClick={changed ? handleSave : handleBack} disabled={saveDisabled()}>{changed ? "SAVE" : "BACK"}</Button>
      </div>
    </div>
  );
}

export default Data;
